import React, { useState } from "react";

const VideoComposer = ({ src, uploading, onCancel, onSend }) => {
  const [caption, setCaption] = useState("");

  const fireSend = () => !uploading && onSend?.(caption.trim());

  const handleKeyDown = (e) => {
    if (e.key === "Escape") onCancel?.();
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      fireSend();
    }
  };

  return (
    <div className="imgc-overlay" role="dialog" aria-modal="true" onClick={onCancel}>
      <div className="imgc-card" onClick={(e) => e.stopPropagation()}>
        <div className="imgc-stage">
          <button
            type="button"
            className="imgc-close"
            title="إغلاق"
            aria-label="إغلاق"
            onClick={onCancel}
            disabled={uploading}
          >
            <i className="bi bi-x-lg"></i>
          </button>

          <video src={src} className="imgc-photo" controls autoPlay muted style={{ maxHeight: "300px", width: "100%" }} />
        </div>

        <div className="imgc-toolbar" dir="rtl">
          <div className="imgc-input">
            <textarea
              className="imgc-caption"
              rows={2}
              placeholder="اكتب رسالتك ..."
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button
              type="button"
              className="icon-btn send-icon imgc-send"
              aria-label="إرسال"
              title="إرسال"
              onClick={fireSend}
              disabled={uploading}
            >
              <i className="bi bi-send-fill fs-4"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoComposer;
